var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.14 162.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #004f7c;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 162.14,
    height: 162.13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "51.48 54.59 29.9 54.59 29.9 37.28 96.39 37.28 96.39 54.59 74.82 54.59 74.82 124.85 51.48 124.85 51.48 54.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "115.57 78.98 103.74 87.4 96.31 76.12 117.54 62.31 132.24 62.31 132.24 124.85 115.57 124.85 115.57 78.98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram1);
export default __webpack_public_path__ + "static/media/tram1.92639d2414f0b970f38abd424d26502a.svg";
export { ForwardRef as ReactComponent };